import CurrencyAmount from '@components/currency-amount/CurrencyAmount';
import Icon from '@components/icon/Icon';

import { MoveToCofeeAction } from './constants';
import { ReviewField } from './types';

import { cofeeOrange300 } from '../../../../../themes/colors';

interface ReviewStepProps {
  action: MoveToCofeeAction;
  fields: ReviewField[];
}

const ReviewStep = ({ action, fields }: ReviewStepProps) => {
  const actionLabels: Record<MoveToCofeeAction, string> = {
    [MoveToCofeeAction.ADD_TO_MEMBER_LIST]: 'Add to Member List',
    [MoveToCofeeAction.QUICK_COLLECT]: 'Quick Collect ( No Group )',
    [MoveToCofeeAction.QUICK_COLLECT_ADD_TO_GROUP]:
      'Quick Collect + Add to Group'
  };

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-start gap-2 rounded-lg border border-cofeeOrange75 bg-cofeeOrange25 p-3">
        <Icon
          name="alert-circle"
          stroke={cofeeOrange300}
          size="medium"
          className="mt-0.5 shrink-0 [&_path]:stroke-cofeeOrange300 [&_path]:[stroke-width:1.5]"
        />
        <div className="flex flex-col">
          <span className="text-sm font-medium text-cofeeOrange300">
            This action is permanent and cannot be undone.
          </span>
          <span className="text-xs text-cofeeNeutral14">
            Please review the details below before confirming.
          </span>
        </div>
      </div>
      <div className="rounded-xl border border-grey30 p-4">
        <div className="flex flex-col gap-3">
          <div className="flex items-center justify-between">
            <span className="text-sm text-cofeeNeutral7">Action</span>
            <span className="text-sm font-medium text-content">
              {actionLabels[action]}
            </span>
          </div>
          {fields.map((field) => (
            <div
              key={field.label}
              className="flex items-start justify-between gap-25"
            >
              <span className="shrink-0 text-sm text-cofeeNeutral7">
                {field.label}
              </span>
              <span className="break-all text-right text-sm font-medium text-content">
                {field.label === 'Amount' ? (
                  <CurrencyAmount value={field.value} />
                ) : (
                  field.value || '-'
                )}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ReviewStep;
